import { ValidPaths } from 'RoutesV2';
import {
  getCommonFacet,
  SCRIBE_COMMON_EVENTS,
  SCRIBE_STATE_NAMES,
  scribeTrackEvent,
} from 'applications/scribe/instrumentations/track';
import InvalidTokenModal from 'components/invalid-token-modal/invalid-token-modal';
import AppMenu from 'components/v2/app-bar/app-menu/app-menu';
import AppSider from 'components/v2/app-bar/app-sider/app-sider';
import Storage from 'grab-storage';
import { Row } from 'grab-ui';
import { grabIDLogout, isPaxUser } from 'helper/grab-id-auth-helper';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { invalidTokenSelector, userInfoSelector } from 'selectors/app-selector';
import {
  getUpdatePasswordRedirectUrl,
  sessionLogout,
} from '../../../helper/session-helper';
import NoticeBanner from '../notice-banner/notice-banner';
import css from './app-bar.less';

export const SESSION_TIMEOUT_TIMES_STORAGE = '__SESSION_TIMEOUT_TIMES__';

export class AppBar extends Component {
  componentDidMount() {
    this.validatePathname();
  }

  componentDidUpdate() {
    this.validatePathname();
  }

  onOkInvalidToken = () => {
    const { invalidToken: { anyoneLoggedIn } } = this.props;

    if (!anyoneLoggedIn) {
      const sessionTimeoutTimes =
        Number(Storage.getItem(SESSION_TIMEOUT_TIMES_STORAGE) || 0) + 1;

      Storage.setItem(
        SESSION_TIMEOUT_TIMES_STORAGE,
        sessionTimeoutTimes.toString(),
      );
    }
    this.doLogout();
  };

  validatePathname = () => {
    const { history } = this.props;
    const { pathname } = history.location;

    if (pathname === '/') {
      history.push('/home');
    } else if (!ValidPaths.includes(pathname)) {
      history.push('/errors');
    }
  };

  doLogout = async () => {
    const { userInfo } = this.props;
    // we want to redirect to ge-homepage for both pax and corp users.
    // in staging and prod, window.Grab.config.uri will be ge-homepage.

    await scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_NAVIGATION,
      eventName: SCRIBE_COMMON_EVENTS.LOGOUT,
      facets: getCommonFacet(userInfo),
      forceUpdate: true,
    });
    if (isPaxUser()) {
      await grabIDLogout();
    } else {
      sessionLogout();
    }
    window.location.href = window.Grab.config.uri;
  };

  doUpdatePassword = async () => {
    const gfbUpdatePasswordUrl = getUpdatePasswordRedirectUrl();
    window.location.href = gfbUpdatePasswordUrl;
  };

  render() {
    const {
      appbarVisible,
      userInfo,
      invalidToken,
      location: { pathname },
    } = this.props;

    return appbarVisible ? (
      <div>
        <div id="appbar" className={css.appbar}>
          <div className={css.appbarContents} id="appbar-content">
            <Row type="flex" justify="space-between">
              <Row type="flex">
                <Link to="/" className={css.grabLogo}>
                  <img
                    alt={'Grab'}
                    src={require('public/images/logo-v2.svg')}
                  />
                </Link>
                <AppSider />
              </Row>
              <AppMenu
                userInfo={userInfo}
                logout={this.doLogout}
                updatePassword={this.doUpdatePassword}
                pathname={pathname}
              />
            </Row>
          </div>
          <InvalidTokenModal
            invalidToken={invalidToken}
            onOk={this.onOkInvalidToken}
          />
        </div>
        <NoticeBanner />
      </div>
    ) : (
      <div className={css.bulkUploadNoticeBanner}>
        <NoticeBanner />
      </div>
    );
  }
}

AppBar.propTypes = {
  appbarVisible: PropTypes.bool.isRequired,
  userInfo: PropTypes.shape({}).isRequired,
  invalidToken: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired,
  location: PropTypes.shape({}).isRequired,
};

export const mapStateToProps = state => ({
  appbarVisible: state.app.appbarVisible,
  invalidToken: invalidTokenSelector(state),
  userInfo: userInfoSelector(state),
});

export default withRouter(connect(mapStateToProps)(AppBar));
